export default "__VITE_ASSET__ceb5ec2b__"